import { SkeletonItem } from '../SkeletonItem'

function TableSkeleton ({
  rowCount,
  columnCount,
  rowClasses,
}: {
  rowCount: number
  columnCount: number
  rowClasses?: string
}) {
  const widthClasses = ['w-1/2', 'w-3/5', 'w-3/4']

  const getRandomWidthClass = () => {
    const randomIndex = Math.floor(Math.random() * widthClasses.length)
    return widthClasses[randomIndex]
  }

  return (
    <div
      className='shadow ring-1 ring-gray-200 rounded-2xl overflow-x-auto bg-white py-2'
      data-testid='TanstackTableSkeleton'
    >
      <table className='min-w-full divide-y divide-gray-200'>
        <thead className='bg-white'>
          <tr>
            {Array.from({ length: columnCount }, (_, index) => (
              <th
                key={`header-${index}`}
                className={`py-2 px-3 first:pl-6 last:pr-6 text-left body-sm text-gray-500 ${rowClasses}`}
              >
                <SkeletonItem heightClass='h-3' />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200 bg-white'>
          {Array.from({ length: rowCount }, (_, index) => (
            <tr key={index}>
              {Array.from({ length: columnCount }, (_, index) => (
                <td
                  key={index}
                  className={`whitespace-nowrap py-2 px-3 first:pl-6 last:pr-6 body ${rowClasses}`}
                >
                  <SkeletonItem widthClass={getRandomWidthClass()} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TableSkeleton
